// Export Rail — PSD §8.5, §8.6 (F8.5, F8.6). Report screen.

import type { ValuationResult } from '@backsolve/shared-types';
import { downloadCsvBundle } from '../../export/spreadsheet';
import { downloadAssumptionMemo } from '../../export/assumptionMemo';
import { BarChart3, FileText } from 'lucide-react';

interface ExportRailProps {
  result: ValuationResult;
}

export function ExportRail({ result }: ExportRailProps) {
  return (
    <div className="card export-rail">
      <h3>Exports</h3>
      <ul className="export-list">
        <li>
          <button className="btn btn-secondary btn-block" onClick={() => downloadCsvBundle(result)}>
            <BarChart3 aria-hidden="true" size={16} /> Spreadsheet (CSV)
          </button>
          <span className="field-hint">Cap table, breakpoints, waterfall, headline</span>
        </li>
        <li>
          <button className="btn btn-secondary btn-block" onClick={() => downloadAssumptionMemo(result)}>
            <FileText aria-hidden="true" size={16} /> Assumption Memo (TXT)
          </button>
          <span className="field-hint">Full assumptions + diagnostics</span>
        </li>
      </ul>
    </div>
  );
}
